import React, { useRef, useState, useMemo, useCallback } from 'react';
import { postData } from '../common/utils';
import { decoratorArray } from '../common/decorator';
import { EditorState, convertToRaw } from 'draft-js';
import AtomicBlockUtils from 'draft-js/lib/AtomicBlockUtils';
import 'draft-js/dist/Draft.css';

//Images
import pf_group from "../../assets/images/pf_group.png";
import pf_tag from "../../assets/images/pf_tag.png";
import pf_smile from "../../assets/images/pf_smile.png";
import pf_gif from "../../assets/images/pf_gif.png";
import pf_image from "../../assets/images/pf_image.png";
import pf_link from "../../assets/images/pf_link.png";

//Mention plugin
import Editor from '@draft-js-plugins/editor';
import "@draft-js-plugins/mention/lib/plugin.css";
import createMentionPlugin, { defaultSuggestionsFilter } from '@draft-js-plugins/mention';

//Export HTML plugin
import { stateToHTML } from 'draft-js-export-html';

//React alert
import { useAlert } from 'react-alert';

//image

var mentions = [];

fetch(process.env.REACT_APP_API_URL + 'api/user/suggestions')
  .then(response => response.json())
  .then(data => mentions = data);

var badges = [];

fetch(process.env.REACT_APP_API_URL + 'api/posts/hashtag')
  .then(response => response.json())
  .then(data => {
    //console.log(data);
    badges = data;
  });

const GifDemo = (props) => {
  //let test = EditorState.createEmpty()
  const alert = useAlert();
  const ref = useRef(null);
  const [editorState, setEditorState] = React.useState(
    () => EditorState.createEmpty(),
  );

  //#region Mention
  function mentionTest(props) {
    return (
      <span style={{ color: '#008bff', fontWeight: 600 }}>{props.decoratedText}</span>
    );
  }
  //Mention
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState(mentions);

  const { MentionSuggestions, mentionPlugin } = useMemo(() => {
    const mentionPlugin = createMentionPlugin({
      mentionPrefix: '@',
      mentionTrigger: '@',
      mentionComponent: mentionTest
    });
    const { MentionSuggestions } = mentionPlugin;
    return { mentionPlugin, MentionSuggestions };
  }, []);

  const onOpenChange = useCallback((_open) => {
    setOpen(_open);
  }, []);
  const onSearchChange = useCallback(({ value }) => {
    setSuggestions(defaultSuggestionsFilter(value, mentions));
  }, []);
  const onAddMention = () => {
    //alert('mention selected');
  }
  //#endregion


  //#region Badges
  function badgeTest(props) {
    return (
      <span className='testing' style={{ color: '#b4b4b4', fontWeight: 600 }}>{props.decoratedText}</span>
    );
  }
  const [open_badges, setOpen_badges] = useState(false);
  const [suggestions_badges, setSuggestions_badges] = useState(badges);
  const { BadgeSuggestions, mentionPlugin_badges } = useMemo(() => {
    const mentionPlugin_badges = createMentionPlugin({
      mentionPrefix: '#',
      mentionTrigger: '#',
      mentionComponent: badgeTest
    });
    const { MentionSuggestions: BadgeSuggestions } = mentionPlugin_badges;
    return { mentionPlugin_badges, BadgeSuggestions };
  }, []);

  const onOpenChange_badges = useCallback((_open) => {
    setOpen_badges(_open);
  }, []);
  const onSearchChange_badges = useCallback(({ value }) => {
    //console.log(value);
    setSuggestions_badges(defaultSuggestionsFilter(value, badges));
  }, []);
  const onAddMention_badges = () => {
    //alert('badge selected');
  }
  //#endregion

  //Editor Plugins
  const plugins = [mentionPlugin, mentionPlugin_badges];

  //#region Form Submit
  const postSubmit = () => {
    var contentState = editorState.getCurrentContent();
    var postJSON = JSON.stringify(convertToRaw(contentState));
    //var blocks = convertToRaw(contentState).blocks;
    //var postString = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    var postString = contentState.getPlainText().trim();
    var postHTML = stateToHTML(contentState);

    //All hashtags
    var allHashtags = postString.match(/[#]\w+/g);
    allHashtags = allHashtags == null ? [] : allHashtags.map(element => {
      return element.substring(1);
    });

    //Get mention count for validation. Only one recipient of pats allowed. Get id of first recipient
    //Get all suggested hashtags/badges. Remove them from allHashtags(Random hashtags that were not suggested)
    var entities = convertToRaw(contentState).entityMap;
    var mentionCount = 0;
    var recipientID = 0;
    var suggestedHashtags = [];
    for (const entity in entities) {
      if (entities[entity].type == "mention") {
        mentionCount++;
        if (mentionCount == 1) {
          recipientID = entities[entity].data.mention.id;
        }
      }
      else if (entities[entity].type == "#mention") {
        suggestedHashtags.push(entities[entity].data.mention);
        //Remove suggestedHashtag from allHashtags
        allHashtags = allHashtags.filter(element => {
          return element !== entities[entity].data.mention.name;
        });
      }
    }

    //Get pats count for validation. +[0-9] is allowed only once
    var patsWithPlus = postString.match(/[+]\d+/g);
    var patsCount = patsWithPlus == null ? 0 : patsWithPlus.length;
    var pats = patsWithPlus == null ? 0 : parseInt(patsWithPlus[0].substring(1));

    //Check if post is empty
    if (postString !== '') {
      //Check if a person is mentioned - @
      if (mentionCount == 1) {
        //Check if pats amount is given
        if (patsCount == 1) {
          //console.log(pats);
          var data = {
            'recipientID': recipientID,
            'pats': pats,
            'allHashtags': allHashtags,
            'suggestedHashtags': suggestedHashtags,
            'postJSON': postJSON,
            'postString': postString,
            'postHTML': postHTML
          }
          postData(process.env.REACT_APP_API_URL + 'api/posts/create', data)
            .then(data => {
              if (data.issuccessful == true) {
                var test = props.refresh;
                props.setRefresh(++test);
                setEditorState(EditorState.createEmpty());
                alert.success(data.message);
              }
              else {
                alert.error(data.message);
              }
            });
        }
        else {
          if (patsCount > 1) {
            alert.error('Specify pats amount only once');
          }
          else if (patsCount < 1) {
            alert.error('Specify pats amount');
          }
        }
      }
      else {
        if (mentionCount > 1) {
          alert.error('Only one person can be mentioned');
        }
        else if (mentionCount < 1) {
          alert.error('One person must be mentioned');
        }
      }
    }
    else {
      alert.error('Empty Post!');
    }

    //console.log(suggestedHashtags,allHashtags);

    // console.log(postJSON);
    // console.log(postString);
    // console.log(postHTML);
  }


  //#endregion

  const insertImage = (url = "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Shaqi_jrvej.jpg/1200px-Shaqi_jrvej.jpg") => {
    //console.log("gif received");
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      'IMAGE',
      'IMMUTABLE',
      //{ src: "https://media.giphy.com/media/dZ8nmFzPpqAb2RGYYC/giphy.gif?cid=ecf05e475c44e53240afc9f3e66645c7bdbc0df16fcf0880&rid=giphy.gif&ct=g" },)
      { src: url },)
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
    // return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, '');
    setEditorState(AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ''))
  };



  return (
    <div className="pf-wrap">
      <div className="pf-tabs">
        <div className="pf-tab">
          <p><span>+</span> Amount</p>
        </div>
        <div className="pf-tab">
          <p><span>@</span> Recipient</p>
        </div>
        <div className="pf-tab">
          <p><span>#</span> Badges</p>
        </div>
      </div>
      <div className="pf-form-wrap">
        <div className="pf-input-wrap">
          {/* <Editor editorState={editorState} onChange={setEditorState} /> */}
          <div
            className="pf-input"
            onClick={() => {
              ref.current.focus();
            }}
          >
            <Editor
              editorKey={'editor'}
              editorState={editorState}
              onChange={setEditorState}
              ref={ref}
              decorators={decoratorArray}
              plugins={plugins}
            />
            <MentionSuggestions
              open={open}
              onOpenChange={onOpenChange}
              suggestions={suggestions}
              onSearchChange={onSearchChange}
              onAddMention={onAddMention}
            />
            <BadgeSuggestions
              open={open_badges}
              onOpenChange={onOpenChange_badges}
              suggestions={suggestions_badges}
              onSearchChange={onSearchChange_badges}
              onAddMention={onAddMention_badges}
            />
          </div>
        </div>
        <div className="pf-btn-wrap">
          <div className="pf-round-wrap">
            {/* <div className="pf-round-item">
              <img src={pf_group} style={{ width: '20px' }} alt="" />
            </div>
            <div className="pf-round-item">
              <img src={pf_tag} alt="" />
            </div> */}
            <div className="pf-round-item">
              <img src={pf_smile} alt="" />
            </div>
            <div className="pf-round-item" onClick={insertImage}>
              <img src={pf_gif} alt="" />
            </div>
            <div className="pf-round-item">
              <img src={pf_image} alt="" />
            </div>
            <div className="pf-round-item">
              <img src={pf_link} alt="" />
            </div>
          </div>
          <div className="pf-give-wrap">
            <button className="blue-btn pf-btn" onClick={postSubmit}>Give!</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GifDemo